export default "__VITE_ASSET__0rL6uGti__"